<template>
  <x-page title="推荐商家" :loading="loading" no-safe-area>
    <div :class="_.page">
      <div :class="_.top">
        <div :class="_.search">
          <img :class="_.icon" src="./images/搜索.png" />
          <van-field
            v-model="params.keyword"
            placeholder="搜索"
            :clearable="true"
            @clear="
              {
                refIndex++, getdata({ pageNumber: 1 })
              }
            "
          />
        </div>
        <div
          :class="_.btn"
          @click="
            {
              refIndex++, getdata({ pageNumber: 1 })
            }
          "
        >
          搜索
        </div>
      </div>

      <div :class="_.bottom">
        <x-waterfall :key="refIndex" :load="getdata">
          <template #default="{ data }">
            <div
              v-for="(item, index) in data"
              :key="index"
              :class="_.listbox"
              @click="toDetail(item.targetUrl)"
            >
              <div :class="_.store">
                <img :src="item.icon" />

                <div :class="_.infos">
                  <div :class="_.name">{{ item.title }}</div>
                  <div :class="[_.intro, _._ellipsis]">
                    {{ item.subTitle }}
                  </div>
                </div>
              </div>

              <x-horizontal-scroll-view :class="_.commodity">
                <div
                  v-for="(child, idc) in item.childList"
                  :key="idc"
                  :class="_.list"
                  @click.stop="toDetail(child.targetUrl)"
                >
                  <img :src="child.icon" />
                  <div :class="[_.name, _._ellipsis]">口红礼盒包装</div>
                  <div :class="_.price">
                    <div :class="_.icon">￥</div>
                    <div :class="_.txt">{{ child.amt }}</div>
                  </div>
                </div>
              </x-horizontal-scroll-view>
            </div>
          </template>
        </x-waterfall>
      </div>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { Track } from '@/utils'

  import { dcb } from '@dcb/jssdk'

  import { apiPageConfigDecorateSearchData } from '@/api'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '推荐商家',
      })),
    ],

    data() {
      return {
        loading: false,
        refIndex: 0,
        params: {
          keyword: '',
          pageSize: 10,
        },
      }
    },

    methods: {
      getdata({ pageNumber }) {
        return apiPageConfigDecorateSearchData({
          id: '老字号推荐商家',
          pageIndex: pageNumber,
          ...this.params,
        })
      },

      toDetail(url) {
        console.log(url)
        dcb.navigateTo({
          url: url,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #f5f5f5;
    height: 100%;

    :global {
      .van-field {
        padding: 0 !important;
        background-color: #f5f5f5 !important;
      }
    }

    .top {
      display: flex;
      align-items: center;
      height: 48px;
      padding: 6px 12px;
      box-sizing: border-box;
      background-color: #ffffff;
      .search {
        display: flex;
        width: 100%;
        height: 100%;
        padding: 0 12px;
        align-items: center;
        background-color: #f5f5f5;
        border-radius: 18px;
        .icon {
          width: 18px;
          height: 18px;
        }
      }
      .btn {
        flex-shrink: 0;
        width: 38px;
        text-align: right;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        margin-left: 12px;
      }
    }

    .bottom {
      height: calc(100% - 58px);
      padding: 12px;
      box-sizing: border-box;
      overflow: scroll;
      .listbox {
        padding: 12px 0px 0px 12px;
        margin-bottom: 12px;
        background: #ffffff;
        border-radius: 8px;
        .store {
          display: flex;
          justify-content: space-between;
          height: 44px;
          padding-right: 12px;
          img {
            width: 44px;
            height: 44px;
            border-radius: 8px;
          }
          .infos {
            width: calc(100% - 54px);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              font-size: 17px;
              font-weight: 600;
              color: #333333;
            }
            .intro {
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }
          }
        }
        .commodity {
          margin-top: 12px;
          .list {
            width: 86px;
            margin-right: 8px;
            background: #ffffff;
            border-radius: 8px;
            img {
              width: 86px;
              height: 86px;
              border-radius: 8px;
            }
            .name {
              font-size: 13px;
              font-weight: 400;
              color: #333333;
            }
            .price {
              display: flex;
              align-items: center;
              color: #ff111c;
              font-weight: 500;
              margin-top: 5px;
              .icon {
                font-size: 11px;
              }
              .txt {
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
</style>
